document.addEventListener('turbolinks:load', function() {
  var fileInput = document.querySelector('.custom-file-input');
  var fileLabel = document.querySelector('.custom-file-label');
  if (fileInput !== null && fileLabel !== null) {
    fileInput.addEventListener("change", (e) => {fileLabel.textContent = e.target.value.replace(/^.*[\\\/]/, ''); });
  }
}, false);